import React from 'react';
import List from "./List";

export default function Actual() {
  return (
    <List isActual={true}/>
  )
}
